import type { TopBarProps } from "./types";
import styles from "./TopBar.module.scss";
import { cn } from "@/lib/cn";

export function TopBar({ children, className, ...rest }: TopBarProps) {
  return (
    <header className={cn(styles.root, className)} {...rest}>
      {children}
    </header>
  );
}
